import { DividerThin } from './Divider.Thin';
import { HorizontalDivider } from './HorizontalDivider';
import { ListItemDivider } from './ListItemDivider';
import { VerticalDivider } from './VerticalDivider';
export var Divider = Object.assign(HorizontalDivider, {
  Horizontal: HorizontalDivider,
  Vertical: VerticalDivider,
  Thin: DividerThin,
  ListItem: ListItemDivider
});